/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
	selector: 'loading-blocker-failure',
	templateUrl: './loading-blocker-failure.component.html',
	styleUrls: ['../loading-blocker.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingBlockerFailureComponent {
	@Input() displayGlobally: boolean = false;

	constructor() {}
}
